import isStreamVideo from '@anm/helpers/is/isStreamVideo';
import { useEffect, useState } from 'react';

import getBestQuality from '../../../helpers/getBestQuality';
import { MediaObject, Player } from '../../../types';

type FullScreenQualityProps = {
  player: Player | null;
  sources: MediaObject[];
};

const useFullScreenQuality = ({ player, sources }: FullScreenQualityProps) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    if (!player || !sources.length) return;

    const bestQualityVideo = getBestQuality(sources);

    const isStream = isStreamVideo(sources[0].path);

    const handleEnterFullScreen = () => {
      setIsFullScreen(true);

      if (!isStream && player.quality !== bestQualityVideo.height) {
        player.quality = bestQualityVideo.height;
      }
    };

    const handleExitFullScreen = () => setIsFullScreen(false);

    player.on('enterfullscreen', handleEnterFullScreen);
    player.on('exitfullscreen', handleExitFullScreen);

    return () => {
      player.off('enterfullscreen', handleEnterFullScreen);
      player.off('exitfullscreen', handleExitFullScreen);
    };
  }, [player, sources.length]);

  return isFullScreen;
};

export default useFullScreenQuality;
